import { render, staticRenderFns } from "./doctor-single.vue?vue&type=template&id=2fd74a43&"
import script from "./doctor-single.vue?vue&type=script&lang=js&"
export * from "./doctor-single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports